import { render, staticRenderFns } from "./AreaEdit.vue?vue&type=template&id=e8f1d7a8&scoped=true&"
import script from "./AreaEdit.vue?vue&type=script&lang=js&"
export * from "./AreaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f1d7a8",
  null
  
)

export default component.exports